import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,HttpRequest } from "@angular/common/http";
import { AuthService } from 'src/app/services/auth/auth.service';
import { AppConfigService } from 'src/app/services/appconfig/app-config.service';
import { ErrorHandlerService } from '../error-handler/error-handler.service';
import { catchError, map } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { AppInsightsService } from 'src/app/services/common/appinsights.service';
import { AdminRequestService } from '../admin-request/admin-request.service';
//import { debug } from 'console';



@Injectable({
  providedIn: 'root'
})
export class BatRequestService {
  private url: string;

  constructor(appConfigService: AppConfigService,
    private http: HttpClient,
    private appInsights: AppInsightsService,
    private adminRequestService: AdminRequestService) {
    
    this.url = appConfigService.get('apiUrl');
  }

  
  getBillingAdjustmentTypes(): Observable<any> {
    
    return this.http.get(this.url + '/Master/GetBillingAdjustmentTypes').pipe(
     map(response => response as any),
     catchError(response => {
       this.appInsights.logException(response);
       return throwError(response);
     })
   );    
}

GetBillingAdjustmentHistoryDetails(request : any) {
  return this.http.post(this.url + '/BillingAdjustment/GetBillingAdjustmentHistoryDetails', request).pipe(
    map(response => <any>response),
    catchError(response => {
      this.appInsights.logException(response);
      return throwError(response);
    })
  );
}

GetBillingAdjustmentRequestDetails(ClientID: string, adjReqId: number,isPRSOrConsolidated: boolean = false, isPRS: boolean = false, isConsolidated: boolean = false ) {
  let params = new HttpParams().set('ClientID', ClientID).set('AdjReqId', adjReqId).set('IsPRSOrConsolidated', isPRSOrConsolidated).set('IsPRS', isPRS).set('IsConsolidated', isConsolidated);
  return this.http.get(this.url + '/BillingAdjustment/GetBillingAdjustmentRequestDetails', { params }).pipe(
    map(response => <any>response),
    catchError(response => {
      this.appInsights.logException(response);
      return throwError(response);
    })
  );
}

/**
 * Downloads the Billing Adjustment PDF for the given Adjustment Request ID.
 *
 * The backend API should generate a PDF that matches the provided screenshot layout and data exactly.
 * The PDF should include:
 *   - All fields, tables, and formatting as shown in the screenshot
 *   - Data for the specified adjReqId
 *   - Return the PDF as a binary blob (application/pdf)
 *
 * @param adjReqId The Adjustment Request ID for which to generate the PDF
 * @returns Observable<Blob> containing the PDF file
 */
GetInvoiceDownloadFile(adjReqId: number) {
  let params = new HttpParams().set('AdjReqId', adjReqId);
  // The backend endpoint should return a PDF file matching the screenshot layout and data
  return this.http.get(this.url + '/BillingAdjustment/DownloadFilesUploaded', {
    params,
    responseType: 'blob', // Expect a PDF blob from backend
  }).pipe(
    map(response => {
      // The response should be a PDF file (application/pdf)
      return response;
    }),
    catchError(error => {
      this.appInsights.logException(error);
      return throwError(error);
    })
  );
}
GetCustomerName(mmsValue: string | number) {
  let params = new HttpParams().set('searchBy', mmsValue.toString());
  return this.http.get(this.url + '/Customers/GetCustomers', { params }).pipe(
    map(response => <any>response),
    catchError(response => {
      this.appInsights.logException(response);
      return throwError(response);
    })
  );
}
saveBillingAdjustment(jsonData:any,edit ): Observable<any> {
  if(edit){
    return this.http.put(this.url + '/BillingAdjustment/UpdateBillingAdjustmentRequest', jsonData).pipe(
      map(response => <any>response),
      catchError(response => {
        this.appInsights.logException(response);
        return throwError(response);
      })
    );
  }
  else{
  return this.http.post(this.url + '/BillingAdjustment/InsertBillingAdjustmentRequest', jsonData).pipe(
    map(response => <any>response),
    catchError(response => {
      this.appInsights.logException(response);
      return throwError(response);
    })
  );
   }
}
uploadBillingAdjustmentFiles(formData: FormData, adjId:any): Observable<any> {

  var headers = new HttpHeaders();
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');

  const req = new HttpRequest('POST', this.url + '/BillingAdjustment/InsertBillingAdjustmentRequestUpload?AdReqId='+adjId, formData, {
    headers: headers,
    reportProgress: true,
    responseType: 'json'
  });


  return this.http.request(req
    // , { : jsonData }headers
  ).pipe(
    map(response => <any>response),
    catchError(response => {
      this.appInsights.logException(response);
      return throwError(response);
    })
  );
}
uploadBillingAdjustmentRequestFiles(formData: FormData, adjId:any): Observable<any> {
  var headers = new HttpHeaders();
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  return this.http.post(this.url + '/BillingAdjustment/InsertBillingAdjustmentRequestUpload?AdReqId='+adjId, formData, {
 headers: headers
  } ).pipe(
    map(response => <any>response),
    catchError(response => {
      this.appInsights.logException(response);
      return throwError(response);
    })
  );
} 
uploadEditBillingAdjustmentRequestFiles(formData: FormData): Observable<any> {
  var headers = new HttpHeaders();
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
   
  return this.http.post(this.url + '/BillingAdjustment/EditBillingAdjustmentRequestUpload', formData, {
 headers: headers
  } ).pipe(
    map(response => <any>response),
    catchError(response => {
      this.appInsights.logException(response);
      return throwError(response);
    })
  );
}

cancelBillingAdjustmentRequest(adjReqId: number, cancelledBy: string): Observable<any> {
  // Create request body with required parameters
  const requestBody = {
    AdjReqId: adjReqId,
    CancelledBy: cancelledBy
  };

  return this.http.put(`${this.url}/BillingAdjustment/CancelBillingAdjustmentRequest`, requestBody)
    .pipe(
      map(response => <any>response),
      catchError(error => {
        this.appInsights.logException(error);
        return throwError(() => error);
      })
    );
}

 getRpfDetails(): Observable<any> {  
        return this.http.get(this.url + '/Master/GetRpfDetails').pipe(
          map(response => response as any),
          catchError(response => {
            this.appInsights.logException(response);
            return throwError(response);
          })
        );
    }
    
    getUserRole(userid : string): Observable<any>
    {
      return this.adminRequestService.userRoles({ CloudId: userid });
    }

}
